export default {"src":"/_next/static/media/ra-employees.275b3539.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};